import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import ChangePassword from "./Pages/ChangePassword";
// import EmailVerification from "./Pages/EmailVerification";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import ForgotPassword from "./Pages/ForgotPassword";
// import ResetPasswordConfirm from "./Pages/ResetPasswordConfirm";
import ThankYouPage from "./Pages/ThankYouPage";
import Signup from "./Pages/Signup";
import Layout from "./High Order Function/Layout";
import Template from "./Pages/Template";
import Dashboard from "./Pages/Dashboard";
// import ResumeContext from './Context/ResumeContext';
import Landp1 from "./Pages/landing/landp1"
import Landp2 from "./Pages/landing/landp2"
import Landp3 from "./Pages/landing/landp3"
import Landp4 from "./Pages/landing/landp4"
import Profile from "./Pages/Profile";
import Pricing from "./Pages/Pricing";
import TermsAndConditions from "./Pages/TermsAndConditions";
import AboutUs from "./Pages/AboutUs";
import Contactus from "./Pages/Contactus";
import "./css/main.css";
import CreateResume from "./Pages/CreateResume";
import CreateResumeForJD from "./Pages/CreateResumeForJD";
import Privacypage from "./Pages/Privacypage";
import Checkout from "./Pages/Checkout";
import Payments from "./Pages/Payments";
import Resume_exmp from "./Pages/resume_exmp";
import { ToastContainer } from 'react-toastify';
import VerifyEmail from "./Pages/VerifyEmail";
import ProtectedRoute from "./High Order Function/ProtectedRoutes";
import ResetPassword from "./Pages/ResetPassword";
import AdminLogin from "./Component/modules/login";
import AdminHome from "./Component/modules/admin";
import AdminProtectedRoute from "./High Order Function/AdminProtectedRout";
import UpdateEmail from "./Pages/update-email";
import AssessmentPage from './Component/modules/assessment/AssessmentPage';
import AddAssessmentPage from './Component/modules/assessment/AddAssessmentPage';
import AiAddAssessmentPage from './Component/modules/assessment/AddAssessmentPage/AiAddAssessmentPage';
import Dashboard1 from './Component/modules/dashboard';
import Adminmanagement from './Component/modules/aam';
import User from './Component/modules/uam';
import Plans from './Component/modules/plan';
import PaymentDetails from './Component/modules/payments';
import Resume from './Component/modules/resume';
import TermsAndConditions1 from './Component/modules/terms-conditions';
import PrivatePolicy from './Component/modules/private-policy';
import TokensConfig from './Component/modules/tokens';
import ContactUs from './Component/modules/contact-us';
import Newsletter from './Component/modules/newsletter';
import AIResume from './Component/modules/ai-resumes';
import Createcoup from './Component/modules/Create-coup';
import MainLayout from './Component/navigation/MainLayout';
import AssessmentDetailsPage from './Component/modules/assessment/AssessmentDetailsPage';
import AssessmentResultsPage from './Component/modules/assessment/AssessmentResultsPage';
import AssessmentPublicPage from './Component/modules/assessment/AssessmentPublicPage'; // New component
import ResultsPage from './Component/modules/assessment/ResultsPage';
import AssessmentDashboard from './Component/modules/assessment/assessmentDashboard';
const App = () => {
  // const resumeContextValue = {
  //   currentTheme: 'Theme1',
  //   showComponent: false,
  //   themeData: {},
  //   componentRef: null
  // };

  return (
    // <ResumeContext.Provider value={resumeContextValue}>
    // <Provider store={Store}>
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="resume-example" element={<Resume_exmp />} />
          <Route path="/lp/build-ats-friendly-resume" element={<Landp1 />} />
          <Route path="lp/ai-optimized-resume" element={<Landp2 />} />
          <Route path="/lp/ai-powered-resume-builder" element={<Landp3 />} />
          <Route path="lp/ai-professional-resume-builder" element={<Landp4 />} />
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          {/* <Route path="change/password" element={<ChangePassword />} /> */}
          <Route path="profile" element={<ProtectedRoute element={<Profile />} />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          {/* <Route path="reset/password/confirm/:uid/:token" element={<ResetPasswordConfirm />} /> */}
          <Route path="dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="terms" element={<TermsAndConditions />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="contact-us" element={<Contactus />} />
          <Route path="privacy" element={<Privacypage />} />
          <Route path="create-resume" element={<ProtectedRoute element={<CreateResume />} />} />
          <Route path="create-resume-forjd" element={<ProtectedRoute element={<CreateResumeForJD />} />} />
          <Route path="template" element={<ProtectedRoute element={<Template />} />} />
          <Route path="checkout" element={<ProtectedRoute element={<Checkout />} />} />
          <Route path="payments" element={<ProtectedRoute element={<Payments />} />} />
          <Route path="verify-email" element={<VerifyEmail />} />
          <Route path="update-email" element={<UpdateEmail />} />
          <Route path="/assessments/:slug/results" element={<ResultsPage />} />
          <Route path="/assessments/:slug/results/:attemptId" element={<ResultsPage />} />
          <Route path="admin/login" element={<AdminLogin />} />
          
          <Route path="/assessments/:slug" element={<AssessmentPublicPage />} />
          <Route path="/assessmentdashboard" element={<AssessmentDashboard />} />
          {/* <Route path="admin" element={<AdminHome />}  /> */}
          {/* <Route path="admin" element={<AdminProtectedRoute element={<AdminHome />} />} /> */}
                    <Route path="/admin" element={<AdminLogin />} />
           <Route element={<MainLayout />}>
                    <Route path="/admin/dashboard" element={<AdminProtectedRoute element={<Dashboard1 />} />} />
                    <Route path="/admin/admin-management" element={<AdminProtectedRoute element={<Adminmanagement />} />} />
                    <Route path="/admin/uam" element={<AdminProtectedRoute element={<User />} />} />
                    <Route path="/admin/plan" element={<AdminProtectedRoute element={<Plans />} />} />
                    <Route path="/admin/payments" element={<AdminProtectedRoute element={<PaymentDetails />} />} />
                    <Route path="/admin/resumes" element={<AdminProtectedRoute element={<Resume />} />} />
                    <Route path="/admin/terms-and-conditions" element={<AdminProtectedRoute element={<TermsAndConditions1 />} />} />
                    <Route path="/admin/privacy-policy" element={<AdminProtectedRoute element={<PrivatePolicy />} />} />
                    <Route path="/admin/tokens" element={<AdminProtectedRoute element={<TokensConfig />} />} />
                    <Route path="/admin/contact-us" element={<AdminProtectedRoute element={<ContactUs />} />} />
                    <Route path="/admin/newsletter" element={<AdminProtectedRoute element={<Newsletter />} />} />
                    <Route path="/admin/ai-resumes" element={<AdminProtectedRoute element={<AIResume />} />} />
                    <Route path="/admin/add-coupon" element={<AdminProtectedRoute element={<Createcoup />} />} />
                    <Route path="/admin/assessments" element={<AdminProtectedRoute element={<AssessmentPage />} />} />
                    <Route path="/admin/ai-assessment" element={<AdminProtectedRoute element={<AiAddAssessmentPage />} />} />
                    <Route path="/admin/add-assessment" element={<AdminProtectedRoute element={<AddAssessmentPage />} />} />
                    <Route path="/admin/assessments/:id" element={<AdminProtectedRoute element={<AssessmentDetailsPage />} />} />
                    <Route path="/admin/assessments/:id/results" element={<AdminProtectedRoute element={<AssessmentResultsPage />} />} />
                    
                    </Route>

        </Routes>
      </Layout>
      <ToastContainer style={{ zIndex: 10000000 }} />
    </Router>
    // </Provider>
    // {/* </ResumeContext.Provider> */}
  );
}

export default App;
